export const FETCH_SETTLEMENTS_REQUEST = "FETCH_SETTLEMENTS_REQUEST";
export const FETCH_SETTLEMENTS_SUCCESS = "FETCH_SETTLEMENTS_SUCCESS";
export const FETCH_SETTLEMENTS_FAILURE = "FETCH_SETTLEMENTS_FAILURE";
